import { motion } from 'framer-motion';

const ExperienceCard = ({ duration, position, company, role, tech }) => {
  return (
    <motion.div
      className='outer-cardbox w-full lg:w-[75%] font-montserrat bg-[#df78451b] md:bg-transparent hover:bg-[#df78451b] p-4 rounded-lg cursor-pointer mb-4 transition-all duration-200 ease-linear'
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 1 }}
    >
      <div className='inner-content'>
        <div className='text-start text-primary duration-panel text-tertiary hidden d-md-block'>
          {duration}
        </div>
        <div className='main-content-panel w-full md:w-[70%]'>
          <div className='text-start position text-2xl text-secondary font-semibold'>
            {position}
          </div>
          <div className='text-start company text-xl text-primary font-semibold'>
            {company}
          </div>
          <div className='text-start fw-bold py-1 d-md-none'>
            {duration}
          </div>
          <div className='role text-[#d3d3d3] text-start'>{role}</div>
          <div className='tech-stack d-flex gap-2 mt-4'>
            {tech.map((item, i) => (
              <div
                className='skill-button bg-warning px-4 py-2 bg-[#2f2d2d6a] text-orange-400 w-fit rounded-full border-[1px] border-[#f8f7f740] text-sm'
                key={i}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ExperienceCard;
